<div *ngIf="loadingRequirements$ | async; else requirements" class="loading-container">
  <mat-spinner diameter="24" class="loading-requirements"></mat-spinner>
  <div class="loading-text">Loading Doc Requirements...</div>
</div>

<ng-template #requirements>
  <div class="deal-document-requirements">
    <!-- OFFER REQUIREMENTS -->
    <div
      class="offer-requirements"
      *ngIf="(documentRequirements$ | async).offerRequirements">
      <div class="offer-documents-header">
        <h2>Offer Documents</h2>
        <div class="add-doc-requirement">
          <app-add-document-button
            *ngIf="!readOnly && deal.stage !== 'funded' && deal.stage !== 'inactive'"
            [documentCategories]="documentCategories$ | async"
            (addDocument)="addDocument($event)">
          </app-add-document-button>
        </div>
      </div>
      <app-deal-document
        *ngFor="let offerRequirement of (documentRequirements$ | async).offerRequirements"
        [documentRequirement]="offerRequirement"
        [documents]="documents$ | async"
        [uploadingDocument]="uploadingDocument$ | async"
        [dealStage]="deal.stage"
        [readOnly]="readOnly"
        (docsUploaded)="uploadDocs($event, 'offerRequirements')"
        (detachDocument)="detachDocument($event, 'offerRequirements')"
        (attachDocument)="attachDocument($event, 'offerRequirements')">
      </app-deal-document>
    </div>

    <!-- CONTRACT REQUIREMENTS -->
    <div
      data-cy="contract-requirements"
      class="contract-requirements"
      *ngIf="shouldDisplayContractRequirements() && (documentRequirements$ | async).contractRequirements && (documentRequirements$ | async).contractRequirements.length > 0">
      <h2>Contract Documents</h2>
      <app-deal-document
        *ngFor="let contractRequirement of (documentRequirements$ | async).contractRequirements"
        [documentRequirement]="contractRequirement"
        [documents]="documents$ | async"
        [uploadingDocument]="uploadingDocument$ | async"
        [dealStage]="deal.stage"
        [readOnly]="readOnly"
        (docsUploaded)="uploadDocs($event, 'contractRequirements')"
        (detachDocument)="detachDocument($event, 'contractRequirements')"
        (attachDocument)="attachDocument($event, 'contractRequirements')">
      </app-deal-document>
    </div>

    <!-- OTHER DEAL DOCS -->
    <div
      data-cy="other-deal-docs"
      class="other-deal-docs"
      *ngIf="(documentRequirements$ | async)?.otherDocs?.length">
      <h2>Additional Documents</h2>
      <app-deal-document
        *ngFor="let otherDoc of (documentRequirements$ | async).otherDocs"
        [documentRequirement]="otherDoc"
        [documents]="documents$ | async"
        [uploadingDocument]="uploadingDocument$ | async"
        [dealStage]="deal.stage"
        [readOnly]="readOnly"
        (docsUploaded)="uploadDocs($event, 'otherDocs')"
        (detachDocument)="detachDocument($event, 'otherDocs')"
        (attachDocument)="attachDocument($event, 'otherDocs')">
      </app-deal-document>
    </div>
  </div>
</ng-template>
